import { render } from "./GrillIcon.vue?vue&type=template&id=88475ed2"
import script from "./GrillIcon.vue?vue&type=script&lang=js"
export * from "./GrillIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__